





































import Vue from 'vue'
export default Vue.extend({

    data() {
        return {
          thisMonth: {
              resolved: 60,
              unresolved: 12,
              withAdvertiser: 20,
              withNetwork: 4,
             other: 2, 
          },  
          lastMonth: {
              resolved: 30,
              unresolved: 20,
              withAdvertiser: 4,
              withNetwork: 1,
              other: 4,
          },
          priorMonth: {
              resolved: 12,
              unresolved: 15,
              withAdvertiser: 2,
              withNetwork: 3,
              other: 4
          }
        }
    }
})
